import React from 'react';

// containers
import Page from '../../layout/containers/Page/Page';
import SearchContainer from '../../containers/SearchContainer/SearchContainer';

// Constants
import page from './page';

const SearchPage = () => {
  return (
    <Page page={page}>
      <SearchContainer />
    </Page>
  );
};

export default SearchPage;
